import { fallbackNavigation } from "../fallback/contentFallbacks";
import { mapNavigation } from "../mappers/wordpressMappers";
import { createServiceResult } from "./serviceResult";
import { fetchNavigation } from "../wordpress/wordpressApi";

export async function getNavigation(options = {}) {
  try {
    const response = await fetchNavigation(options);

    return createServiceResult({
      data: mapNavigation(response.data),
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: fallbackNavigation,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}
